export default __webpack_public_path__ + "static/media/megaphone.3b3e35a1.svg";